export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pt": {
        "fallback-text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conteúdo vazio. Clique em 'Adicionar' para criar um novo conteúdo."])}
      }
    }
  })
}